import Form, { IForm } from "./Form";
import GenderEnum from "@/config/genderEnum"

import editMandatoryFieldsSet from "@/config/edit_form_mandatory.config"
import { CSEService } from "../../service/CSEService";
import locale from "@/state/locale";

export interface IEditForm extends IForm {
    gender: GenderEnum
    first_name: string
    last_name: string
    address: string
    city: string
    postal_code: string
    country: string
    phone_code: string
    phone_number: string
    subscribe_newsletter?: boolean | undefined
    locale: string
    getIsFormValid(): boolean
}

export default class EditForm extends Form implements IEditForm {
    public gender = GenderEnum.None
    public first_name = ''
    public last_name = ''
    public address = ''
    public city = ''
    public postal_code = ''
    public country = ''
    public phone_code = ''
    public phone_number = ''
    public locale = ''
    public subscribe_newsletter?: boolean | undefined = false

    constructor(_locale: string | null) {
        super()
        if (!_locale) throw new Error("locale.value cannot be undefined")

        this.locale = _locale
        const cseService: CSEService = new CSEService(this.locale)
        if (cseService.isCSE) cseService.init()
        if (cseService.isCSE && cseService.isCGOS) {
            if (!cseService.firstName || !cseService.lastName) throw new Error("firstName and lastName in CSEService cannot be undefined");
            this.first_name = cseService.firstName
            this.last_name = cseService.lastName
        }


    }

    public getIsFormValid(): boolean {
        if (editMandatoryFieldsSet.has("gender") && !this.gender) return false
        if (editMandatoryFieldsSet.has("first_name") && !this.first_name) return false
        if (editMandatoryFieldsSet.has("last_name") && !this.last_name) return false
        if (editMandatoryFieldsSet.has("address") && !this.address) return false
        if (editMandatoryFieldsSet.has("city") && !this.city) return false
        if (editMandatoryFieldsSet.has("postal_code") && !this.postal_code) return false
        if (editMandatoryFieldsSet.has("country") && !this.country) return false
        if (editMandatoryFieldsSet.has("phone_code") && !this.phone_code) return false
        if (editMandatoryFieldsSet.has("phone_number") && !this.phone_number) return false
        if (editMandatoryFieldsSet.has("subscribe_newsletter") && !this.subscribe_newsletter) return false

        return true
    }
}